
import { useContext, useState } from "react";
import Loading from "../../Loading";
import DeleteButton from "../../components/DeleteButton";
import { UserContext } from "../../../../Context";
import HtTabs from "../../components/HtTabs";
import FormatDateTime from "../../components/FormatDateTime";
import useDBO from "../../hooks/useDBO";
import AddButton from "../../components/AddButton";
import NewShiftDialog from "./NewShiftDialog";
import HtClass from "../../components/HtClass";
import Lang from "../../components/Lang";
import IconButtonHT from "../../components/IconButtonHT";
import useCTX from "../../hooks/useCTX";
import Icon from "../../Icon";
import mut from "../../hooks/mut";
import { useNavigate, useParams } from "react-router-dom";
import DateChoice from "../../components/DateChoice";
import Time from "../../components/Time";
import sdate from "@timclark/sdate";
import "./staffShifts.css";
import PremiumStaffBadge from "../../components/PremiumStaffBadge";
/* import ForeignTeacher from "./ForeignTeacher"; */

export default function StaffShifts() {
  const [newShiftDialog, setNewShiftDialog] = useState(false);
  const { user } = useContext(UserContext)
  const {tDate} = useParams()
  const sd = new sdate(tDate)

  const shifts = useDBO(
    `/staff/shifts2/${tDate}`,60
  );
  const navigate = useNavigate()
 
  return (
    <div className="shifts-container">
      <header className="shifts-header">
        <h1>Shifts for staff today</h1>
        <div className="shifts-header-actions">
          <IconButtonHT
            icon="leftChevron"
            action={() => {
           
              navigate(`/staffshifts/${sd.addDays(-1)}`);
            }}
          />
          <DateChoice
            value={tDate}
            setValue={(ntDate) => {
              navigate(`/staffshifts/${ntDate}`);
            }}
            future={false}
          />
          <IconButtonHT
            icon="rightChevron"
            action={() => {
              let nd = new sdate(tDate);
              navigate(`/staffshifts/${sd.addDays(1)}`);
            }}
            disabled={tDate >= new sdate()}
          />

          <AddButton
            action={() => setNewShiftDialog(true)}
            disabled={!sd.isToday() && !user.roles.includes("Owner")}
          />
        </div>
      </header>
      {
        <DrawTabs
          shifts={shifts}
          newShiftDialog={newShiftDialog}
          setNewShiftDialog={setNewShiftDialog}
          showDate={tDate}
        />
      }
    </div>
  );
}



function DrawTabs({shifts, newShiftDialog,setNewShiftDialog,showDate}){ 

  const {locations} = useCTX()
  if(shifts.loading) return <Loading />;
  const labels = locations.map(
      (l) =>
        `${l.name} (${shifts.get.filter((s) => s.location === l._id).length})`
    );
  const components = locations.map((l) => (
      <DrawLocation
        shifts={shifts}
        location={l._id}
      key={l._id}
      showDate={showDate}
      />
    ));
  return (
    <>
      <HtTabs
        labels={labels}
        components={components}
        localStorage="location"
      />
      <NewShiftDialog open={newShiftDialog} setOpen={setNewShiftDialog} showDate={showDate} shifts={shifts}/>
    </>
  );
}


function DrawLocation({ shifts, location, ft, showDate }) {
  
  const staff = [...new Set(shifts.get.filter(s=>s.location===location).map((s) => s.user))]
 
  return (
    <div className="shifts-grid-view">
      <div className="shifts-board">
        <div className="shifts-board-header">
          <div className="header-sidebar-spacer">
             <div className="header-col"><Lang w="staff" /></div>
          </div>
          <div className="shift-grid-headers">
            <div className="header-col"><Lang w="startTime" /></div>
            <div className="header-col"><Lang w="finishTime" /></div>
            <div className="header-col"><Lang w="hours" /></div>
            <div className="header-col"><Lang w="recordedBy" /></div>
            <div className="header-col"><Lang w="role" /></div>
            <div className="header-col"><Lang w="class" /></div>
            <div className="header-col"><Lang w="checkedBy" /></div>
            <div></div> {/* Spacer */}
            <div></div> {/* Actions */}
          </div>
        </div>
        <div className="shifts-board-body">
            {staff.map((s) => (
              <DrawShift
                key={s._id || s}
                staff={s}
                shifts={shifts}
                location={location}
                showDate={showDate}
              />
            ))}
        </div>
      </div>
    </div>
  );
}

function DrawShift(props) {
  let { staff, shifts, location } = props;
  return (
    <div className="staff-group-row">
      <aside className="staff-group-left">
        <PremiumStaffBadge id={staff} />
      </aside>

      <div className="staff-group-right">
        {shifts.get
          .filter((s) => s.user === staff && s.location === location)
          .map((shift) => (
            <div key={shift._id} className="shift-row">
              <div className="board-cell">
                 <Time time={shift.startTime} />
              </div>
              <div className="board-cell">
                 <Time time={shift.endTime} />
              </div>
              <div className="board-cell" style={{fontWeight: 800}}>
                 {shift.hours}
              </div>
              <div className="board-cell">
                 <div><PremiumStaffBadge id={shift.recordedBy} size="small" /></div>
                 <div className="small-meta"><FormatDateTime value={shift.createdAt} /></div>
              </div>
              <div className="board-cell" style={{fontWeight: 700}}>
                 {shift.role}
              </div>
              <div className="board-cell">
                 {shift.htClass && <HtClass htClass={shift.htClass} />}
              </div>
              <div className="board-cell">
                 <Checked shift={shift} shifts={shifts} />
              </div>
              <div></div> {/* Spacer */}
              <div style={{ justifySelf: "end" }}>
                <DeleteButton
                  route="/shifts"
                  id={shift._id}
                  success={() => shifts.remove(shift)}
                  size={30}
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

function Checked({ shift,shifts }) {
  const { user } = useCTX()
  const [loading,setLoading] = useState(false)
  
  if (shift.checked) return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <div className="status-pill checked">
         <Icon name="tick" /> 
         <span>Verified</span>
      </div>
      <div className="small-meta">
        <PremiumStaffBadge id={shift.checkedBy} size="small" />
      </div>
    </div>
  );

  const check = async () => {
    setLoading(true)
    let res = await mut("post", `/check-shift/${shift._id}`, {})
    if (!res.error) {
      shifts.replace(res)   
      setLoading(false)
    } else {
      setLoading(false);
      alert("Couldn't check shift, please try again")
    }
  }

  let disabled = true
  if (user._id !== shift.recordedBy) disabled = false

  return (
    <button 
      className="status-check-btn"
      onClick={!disabled ? check : undefined}
      disabled={disabled || loading}
    >
      <div className={`status-pill ${disabled ? 'disabled' : 'pending'}`}>
          {loading ? "..." : (disabled ? <Lang w="cantCheck" /> : <Lang w="check" />)}
      </div>
    </button>
  );
}
